import { alpha } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { get } from 'global/lib/lodash';

const getColor = (props, theme, key) => {
  let color = props.bgColor;
  if (props.disabled || ['outlined', 'none', 'text'].includes(props.variant)) {
    return undefined;
  }
  if (props.variant === 'default') {
    color = 'rgba(0,0,0,0.0)';
  } else if (props.bgColor === 'primary' || props.bgColor === 'secondary') {
    color = get(theme.palette, [props.bgColor]);

    if (key) {
      color = get(color, key);
    }
  }

  return color;
};

const getFade = (props, theme) => {
  const color = getColor(props, theme);

  if (props.disabled || ['default', 'outlined', 'none', 'text'].includes(props.variant)) {
    return get(theme, 'palette.action.hover');
  }
  if (typeof color === 'string') {
    return alpha(color, 0.9);
  }
  return get(color, 'light');
};

const getContrastText = (props, theme) => {
  const color = getColor(props, theme);

  if (props.disabled || ['outlined', 'none', 'text'].includes(props.variant)) {
    return undefined;
  } else if (props.variant === 'default') {
    return get(theme.palette, [props.color || 'primary', 'main']);
  }
  if (typeof color === 'string') {
    return theme.palette.getContrastText(color);
  }

  return color.contrastText;
};

const useStyles = makeStyles((theme) => ({
  root: {
    color: (p) => p.textColor || getContrastText(p, theme),
    backgroundColor: (p) => getColor(p, theme, 'main'),
    '&:hover': {
      backgroundColor: (p) => getFade(p, theme),
    },
    '& .MuiCircularProgress-root': {
      color: (p) => getContrastText(p, theme),
      margin: theme.spacing(0.5),
    },
  },
}));

export default useStyles;
